export const styles = {
    pageContainer: {
        height: "100vh",
        height: "100vh",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        width:{
            xs:"auto",
            sm:"550px"
          },
          margin:{
            xs:"0 15px",
            sm:"0 auto"
          },
    },  
    button: {
        margin: "16px 16px 16px 0",
        fontSize: "18px",
        textTransform: "uppercase"
    },
    formContainer: {
        padding: "30px 0",
        width:"100%",
        margin:"0 auto",
    },
    formInput: {
        margin: "10px 0",
    },
    subtitle:{
        paddingBottom:"10px"
    },
    formButton:{
        marginTop:2
      },
}